import { overlayStrategemFadeMs } from './overlayStrategemTiming';

/** Strategem 313 (Duplicate): fade-in target art on friendly unit */
export const DUPLICATE_TARGET_IMAGE_PATH = '/images/duplicate_target.png';
export const DUPLICATE_SOUND_PATH = '/sounds/duplicate.mp3';
export const DUPLICATE_TARGET_FADE_DURATION_MS = overlayStrategemFadeMs(313);

/** Same pixel sizing as StrategemTargetAnimation (unit) — use in hand overlay for a visual match */
export const DUPLICATE_TARGET_IMAGE_STYLE = {
  width: 'min(44vw, 220px)',
  height: 'auto',
  objectFit: 'contain',
  filter: 'drop-shadow(0 0 14px rgba(160, 140, 255, 0.55))',
};

/**
 * Centering model matches StrategemTargetAnimation duplicate overlay:
 * fixed overlay uses translate(-50%, -50%) from the target point.
 * Use inside a full-bleed layer over the order card art (OrderDesign bounds), not the whole carousel shell.
 */
export const DUPLICATE_TARGET_CENTERED_IMAGE_STYLE = {
  ...DUPLICATE_TARGET_IMAGE_STYLE,
  display: 'block',
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
};

/**
 * OrderDesign’s minimal hand root uses `translateY(40px)` when `!zoneName` (see OrderDesign.js).
 * The duplicate overlay is a sibling — apply this on the overlay layer so FX aligns with the card art.
 */
export const DUPLICATE_HAND_OVERLAY_MATCH_ORDER_DESIGN_TRANSFORM = 'translateY(40px)';
